export const COPY_RIGHTS= 'Scanship 2020';
export const VOW_LINK = 'https://www.vowasa.com/';
